import { REDUCERS } from "../../constants";
import { eventActions, eventTypes } from "../../socketConstants";
import { enhanceUploads } from "./helpers";

const uploadEnhancer = ({ dispatch, getState }) => next => async action => {
    if (
        [`${REDUCERS.UPLOADS}/fetchUploadsInBatch/fulfilled`].includes(
            action.type
        )
    ) {
        const uploads = action.payload;
        const enhancedUploads = enhanceUploads(
            uploads,
            getState().uploads.entities
        );

        return next({
            ...action,
            payload: enhancedUploads
        });
    }

    if (
        action.type === `${eventTypes.UPLOAD}/${eventActions.UPDATE}` ||
        action.type === `${REDUCERS.UPLOADS}/updateUpload`
    ) {
        const upload = action.payload;
        const enhancedUploads = await enhanceUploads(
            [upload],
            getState().uploads.entities
        );

        return next({
            ...action,
            payload: enhancedUploads[0]
        });
    }

    return typeof action === "function"
        ? action(dispatch, getState)
        : next(action);
};

export default uploadEnhancer;
